import { ErrorIllustration, StatusScreen } from "@kaltura/mediaspace-shared-ui";

export interface SchedulingErrorProps {
    title: string;
    text: string;
}

/**
 * media page scheduling error screen
 */
const SchedulingError = (props: SchedulingErrorProps) => {
    const { title, text } = props;

    return <StatusScreen title={title} text={text} image={<ErrorIllustration />} contentWidth={620} />;
};

export default SchedulingError;
